// Generated by scripts/generate-public-surface.ts. Do not edit.
export const registryMetadata = [
  {
    abbreviation: "NRT",
    aliases: ["NRT", "Número de Registre Tributari"],
    canGenerate: true,
    candidatePattern: "[A-Z]-?\\d{6}-?[A-Z]",
    country: "AD",
    description: null,
    entityType: "any",
    examples: ["U132950X", "D059888N", "F123456M"],
    exportName: "nrt",
    id: "ad.nrt",
    lengths: [],
    localName: "Número de Registre Tributari",
    name: "Andorra Tax Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ad",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Andorra-TIN.pdf",
    subpath: "ad/nrt",
  },
  {
    abbreviation: "EID",
    aliases: ["EID", "Emirates ID", "رقم الهوية"],
    canGenerate: true,
    candidatePattern: "784-\\d{4}-\\d{7}-\\d",
    country: "AE",
    description:
      "15-digit identity number issued to UAE residents",
    entityType: "person",
    examples: [
      "784198012345678",
      "784197912345671",
      "784195204640486",
      "784196865703050",
    ],
    exportName: "eid",
    id: "ae.eid",
    lengths: [15],
    localName: "رقم الهوية",
    name: "Emirates ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ae",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://u.ae/en/information-and-services/visa-and-emirates-id/emirates-id",
    subpath: "ae/eid",
  },
  {
    abbreviation: "TIN",
    aliases: ["TIN"],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "AI",
    description:
      "Anguilla tax number issued by the Inland Revenue Department",
    entityType: "any",
    examples: ["1234567890", "2345678901"],
    exportName: "tin",
    id: "ai.tin",
    lengths: [10],
    localName: "Tax Identification Number",
    name: "Anguilla Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ai",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Anguilla-TIN.pdf",
    subpath: "ai/tin",
  },
  {
    abbreviation: "NIPT",
    aliases: ["NIPT", "NUIS"],
    canGenerate: true,
    candidatePattern: "[A-Z]\\d{8}[A-Z]",
    country: "AL",
    description: null,
    entityType: "any",
    examples: ["J91402501L", "K22218003V"],
    exportName: "nipt",
    id: "al.nipt",
    lengths: [],
    localName:
      "Numri i Identifikimit për Personin e Tatueshëm",
    name: "Albanian Tax Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "al",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.tatime.gov.al/",
    subpath: "al/nipt",
  },
  {
    abbreviation: "TIN",
    aliases: ["ՀՎՀՀ", "TIN"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "AM",
    description: null,
    entityType: "any",
    examples: ["01234561", "10048376"],
    exportName: "tin",
    id: "am.tin",
    lengths: [8],
    localName: "Հարկ վճարողի հաշվառման համար",
    name: "Armenian Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "am",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Armenia-TIN.pdf",
    subpath: "am/tin",
  },
  {
    abbreviation: "CBU",
    aliases: ["CBU", "Clave Bancaria Uniforme"],
    canGenerate: true,
    candidatePattern: "\\d{22}",
    country: "AR",
    description: null,
    entityType: "any",
    examples: ["2850590940090418135201"],
    exportName: "cbu",
    id: "ar.cbu",
    lengths: [22],
    localName: "Clave Bancaria Uniforme",
    name: "Argentine Bank Account Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ar",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://es.wikipedia.org/wiki/Clave_bancaria_uniforme",
    subpath: "ar/cbu",
  },
  {
    abbreviation: "CUIT",
    aliases: [
      "CUIT",
      "CUIL",
      "Clave Única de Identificación Tributaria",
    ],
    canGenerate: true,
    candidatePattern: "\\d{2}-?\\d{8}-?\\d",
    country: "AR",
    description: null,
    entityType: "any",
    examples: ["20267565393", "20055361682"],
    exportName: "cuit",
    id: "ar.cuit",
    lengths: [11],
    localName: "Clave Única de Identificación Tributaria",
    name: "Argentine Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ar",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.afip.gob.ar/",
    subpath: "ar/cuit",
  },
  {
    abbreviation: "DNI",
    aliases: [
      "DNI",
      "Documento Nacional de Identidad",
      "Documento de Identidad",
    ],
    canGenerate: true,
    candidatePattern: "\\d{1,2}\\.?\\d{3}\\.?\\d{3}",
    country: "AR",
    description: null,
    entityType: "person",
    examples: ["20123456", "12345678"],
    exportName: "dni",
    id: "ar.dni",
    lengths: [7, 8],
    localName: "Documento Nacional de Identidad",
    name: "Argentine Identity Card",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ar",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Documento_Nacional_de_Identidad_(Argentina)",
    subpath: "ar/dni",
  },
  {
    abbreviation: "FN",
    aliases: ["Firmenbuchnummer", "FN", "FBN"],
    canGenerate: true,
    candidatePattern: "FN\\s?\\d{5,6}[a-z]?",
    country: "AT",
    description: null,
    entityType: "company",
    examples: ["122119m"],
    exportName: "businessid",
    id: "at.businessid",
    lengths: [],
    localName: "Firmenbuchnummer",
    name: "Austrian Company Register Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "at",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.justiz.gv.at/",
    subpath: "at/businessid",
  },
  {
    abbreviation: "TIN",
    aliases: ["Steuernummer", "St.Nr.", "TIN"],
    canGenerate: true,
    candidatePattern: "\\d{2}-?\\d{3}/\\d{4}",
    country: "AT",
    description: null,
    entityType: "any",
    examples: ["591199013"],
    exportName: "tin",
    id: "at.tin",
    lengths: [],
    localName: "Abgabenkontonummer",
    name: "Austrian Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "at",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://de.wikipedia.org/wiki/Abgabenkontonummer",
    subpath: "at/tin",
  },
  {
    abbreviation: "UID",
    aliases: [
      "UID",
      "Umsatzsteuer-Identifikationsnummer",
      "ATU",
    ],
    canGenerate: true,
    candidatePattern: "ATU\\d{8}",
    country: "AT",
    description: null,
    entityType: "company",
    examples: ["U13585627"],
    exportName: "uid",
    id: "at.uid",
    lengths: [],
    localName: "Umsatzsteuer-Identifikationsnummer",
    name: "Austrian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "at",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.bmf.gv.at/",
    subpath: "at/uid",
  },
  {
    abbreviation: "VNR",
    aliases: [
      "VNR",
      "SVNR",
      "Versicherungsnummer",
      "Sozialversicherungsnummer",
    ],
    canGenerate: true,
    candidatePattern: "\\d{4}\\s?\\d{6}",
    country: "AT",
    description: null,
    entityType: "person",
    examples: ["1237010180"],
    exportName: "vnr",
    id: "at.vnr",
    lengths: [10],
    localName: "Versicherungsnummer",
    name: "Austrian Social Insurance Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "at",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://de.wikipedia.org/wiki/Sozialversicherungsnummer",
    subpath: "at/vnr",
  },
  {
    abbreviation: "ABN",
    aliases: ["ABN", "Australian Business Number"],
    canGenerate: true,
    candidatePattern:
      "\\d{2}\\s?\\d{3}\\s?\\d{3}\\s?\\d{3}",
    country: "AU",
    description: null,
    entityType: "company",
    examples: ["83914571673", "51824753556"],
    exportName: "abn",
    id: "au.abn",
    lengths: [],
    localName: "Australian Business Number",
    name: "Australian Business Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "au",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://abr.business.gov.au/",
    subpath: "au/abn",
  },
  {
    abbreviation: "ACN",
    aliases: ["ACN", "Australian Company Number"],
    canGenerate: true,
    candidatePattern: "\\d{3}\\s?\\d{3}\\s?\\d{3}",
    country: "AU",
    description: null,
    entityType: "company",
    examples: ["004085616", "010499966"],
    exportName: "acn",
    id: "au.acn",
    lengths: [],
    localName: "Australian Company Number",
    name: "Australian Company Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "au",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://asic.gov.au/",
    subpath: "au/acn",
  },
  {
    abbreviation: "TFN",
    aliases: ["TFN", "Tax File Number"],
    canGenerate: true,
    candidatePattern: "\\d{8,9}",
    country: "AU",
    description: null,
    entityType: "person",
    examples: ["87650006", "123456782"],
    exportName: "tfn",
    id: "au.tfn",
    lengths: [],
    localName: "Tax File Number",
    name: "Tax File Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "au",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.ato.gov.au/individuals-and-families/tax-file-number",
    subpath: "au/tfn",
  },
  {
    abbreviation: "VÖEN",
    aliases: ["VÖEN"],
    canGenerate: true,
    candidatePattern: "\\d{10}",
    country: "AZ",
    description: null,
    entityType: "any",
    examples: ["1401555071", "1400057421"],
    exportName: "voen",
    id: "az.voen",
    lengths: [10],
    localName: "Vergi Ödəyicisinin Eyniləşdirmə Nömrəsi",
    name: "Azerbaijani Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "az",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.taxes.gov.az/",
    subpath: "az/voen",
  },
  {
    abbreviation: "JMBG",
    aliases: ["JMBG", "matični broj"],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "BA",
    description: null,
    entityType: "person",
    examples: ["0101006500006"],
    exportName: "jmbg",
    id: "ba.jmbg",
    lengths: [13],
    localName: "Jedinstveni matični broj građana",
    name: "Bosnian Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "ba",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/",
    subpath: "ba/jmbg",
  },
  {
    abbreviation: "NID",
    aliases: ["NID", "জাতীয় পরিচয়পত্র", "National ID Card"],
    canGenerate: true,
    candidatePattern: "\\d{10,17}",
    country: "BD",
    description:
      "National identity number issued by the Bangladesh Election Commission",
    entityType: "person",
    examples: [
      "1592824588424",
      "19841592824588424",
      "2610413965404",
      "19892610413965404",
    ],
    exportName: "nid",
    id: "bd.nid",
    lengths: [10, 13, 17],
    localName: "জাতীয় পরিচয়পত্র",
    name: "National Identity Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "bd",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.nidw.gov.bd/",
    subpath: "bd/nid",
  },
  {
    abbreviation: "BIS",
    aliases: ["BIS-nummer", "numéro BIS"],
    canGenerate: true,
    candidatePattern:
      "\\d{2}\\.?\\d{2}\\.?\\d{2}-?\\d{3}\\.?\\d{2}",
    country: "BE",
    description: null,
    entityType: "person",
    examples: ["98472899765"],
    exportName: "bis",
    id: "be.bis",
    lengths: [],
    localName: "BIS-nummer",
    name: "Belgian BIS Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "be",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://sma-help.bosa.belgium.be/en/faq/where-can-i-find-my-bis-number",
    subpath: "be/bis",
  },
  {
    abbreviation: "NN",
    aliases: [
      "rijksregisternummer",
      "numéro national",
      "NN",
    ],
    canGenerate: true,
    candidatePattern:
      "\\d{2}\\.?\\d{2}\\.?\\d{2}-?\\d{3}\\.?\\d{2}",
    country: "BE",
    description: null,
    entityType: "person",
    examples: ["93051822361"],
    exportName: "nn",
    id: "be.nn",
    lengths: [],
    localName: "Numéro national",
    name: "Belgian National Number",
    namedExports: [
      "checksum",
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "be",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.ibz.rrn.fgov.be/",
    subpath: "be/nn",
  },
  {
    abbreviation: "BTW",
    aliases: [
      "BTW",
      "TVA",
      "numéro d'entreprise",
      "ondernemingsnummer",
    ],
    canGenerate: true,
    candidatePattern: "BE0?\\d{9,10}",
    country: "BE",
    description: null,
    entityType: "company",
    examples: ["0776091951"],
    exportName: "vat",
    id: "be.vat",
    lengths: [],
    localName: "BTW-identificatienummer",
    name: "Belgian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "be",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://finances.belgium.be/",
    subpath: "be/vat",
  },
  {
    abbreviation: "ЕГН",
    aliases: ["ЕГН", "единен граждански номер", "EGN"],
    canGenerate: true,
    candidatePattern: "\\d{10}",
    country: "BG",
    description: null,
    entityType: "person",
    examples: ["7523169263"],
    exportName: "egn",
    id: "bg.egn",
    lengths: [],
    localName: "Единен граждански номер",
    name: "Bulgarian Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "bg",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.grao.bg/normact/NaredbaFunkcESGR.pdf",
    subpath: "bg/egn",
  },
  {
    abbreviation: "ЛНЧ",
    aliases: ["ЛНЧ", "личен номер на чужденец", "PNF"],
    canGenerate: true,
    candidatePattern: "\\d{10}",
    country: "BG",
    description: null,
    entityType: "person",
    examples: ["7111042925"],
    exportName: "pnf",
    id: "bg.pnf",
    lengths: [],
    localName: "Личен номер на чужденец",
    name: "Bulgarian Foreigner Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "bg",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Unique_citizenship_number",
    subpath: "bg/pnf",
  },
  {
    abbreviation: "ИН по ДДС",
    aliases: ["ДДС", "идентификационен номер по ДДС"],
    canGenerate: true,
    candidatePattern: "BG\\d{9,10}",
    country: "BG",
    description: null,
    entityType: "any",
    examples: ["175074752"],
    exportName: "vat",
    id: "bg.vat",
    lengths: [9, 10],
    localName: "ИН по ДДС",
    name: "Bulgarian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "bg",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.nra.bg/",
    subpath: "bg/vat",
  },
  {
    abbreviation: "CPR",
    aliases: ["CPR", "الرقم السكاني"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "BH",
    description: "9-digit personal identification number",
    entityType: "person",
    examples: ["890112345", "000612345"],
    exportName: "cpr",
    id: "bh.cpr",
    lengths: [9],
    localName: "الرقم السكاني",
    name: "Central Population Registration Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "bh",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.bahrain.bh/wps/portal/IDInfo_en",
    subpath: "bh/cpr",
  },
  {
    abbreviation: "BIC",
    aliases: ["BIC", "SWIFT", "BIC/SWIFT"],
    canGenerate: true,
    candidatePattern: "[A-Z]{6}[A-Z0-9]{2}(?:[A-Z0-9]{3})?",
    country: null,
    description: null,
    entityType: "company",
    examples: ["DEUTDEFF", "DEUTDEFF500"],
    exportName: "bic",
    id: "bic",
    lengths: [],
    localName: "Business Identifier Code",
    name: "Business Identifier Code",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: null,
    parseKind: null,
    scope: "global",
    sourceUrl: "https://www.swift.com/",
    subpath: "bic",
  },
  {
    abbreviation: "CNPJ",
    aliases: [
      "CNPJ",
      "Cadastro Nacional da Pessoa Jurídica",
    ],
    canGenerate: true,
    candidatePattern:
      "\\d{2}\\.?\\d{3}\\.?\\d{3}/?\\d{4}-?\\d{2}",
    country: "BR",
    description: null,
    entityType: "company",
    examples: ["33000167000101", "00000000000191"],
    exportName: "cnpj",
    id: "br.cnpj",
    lengths: [],
    localName: "Cadastro Nacional da Pessoa Jurídica",
    name: "Brazilian CNPJ",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "br",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.gov.br/receitafederal/",
    subpath: "br/cnpj",
  },
  {
    abbreviation: "CPF",
    aliases: ["CPF", "Cadastro de Pessoas Físicas"],
    canGenerate: true,
    candidatePattern: "\\d{3}\\.?\\d{3}\\.?\\d{3}-?\\d{2}",
    country: "BR",
    description: null,
    entityType: "person",
    examples: ["39053344705"],
    exportName: "cpf",
    id: "br.cpf",
    lengths: [],
    localName: "Cadastro de Pessoas Físicas",
    name: "Brazilian CPF",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "br",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.gov.br/receitafederal/",
    subpath: "br/cpf",
  },
  {
    abbreviation: "УНП",
    aliases: ["УНП", "UNP"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "BY",
    description: null,
    entityType: "any",
    examples: ["200988541", "MA1953684"],
    exportName: "unp",
    id: "by.unp",
    lengths: [],
    localName: "Учётный номер плательщика",
    name: "Belarus Tax Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "by",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.nalog.gov.by/",
    subpath: "by/unp",
  },
  {
    abbreviation: "TIN",
    aliases: ["TIN"],
    canGenerate: true,
    candidatePattern: "\\d{6}",
    country: "BZ",
    description:
      "Belize tax number issued by the Belize Tax Service Department",
    entityType: "any",
    examples: ["000005", "00000510", "00000513"],
    exportName: "tin",
    id: "bz.tin",
    lengths: [6, 8],
    localName: "Tax Identification Number",
    name: "Belize Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "bz",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Belize-TIN.pdf",
    subpath: "bz/tin",
  },
  {
    abbreviation: "BN",
    aliases: [
      "BN",
      "Business Number",
      "numéro d'entreprise",
    ],
    canGenerate: true,
    candidatePattern: "\\d{9}\\s?[A-Z]{2}\\s?\\d{4}",
    country: "CA",
    description: null,
    entityType: "company",
    examples: ["123026635", "123026635RC0001"],
    exportName: "bn",
    id: "ca.bn",
    lengths: [],
    localName: "Business Number",
    name: "Business Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ca",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.canada.ca/en/services/taxes/business-number.html",
    subpath: "ca/bn",
  },
  {
    abbreviation: "SIN",
    aliases: ["SIN", "Social Insurance Number", "NAS"],
    canGenerate: true,
    candidatePattern: "\\d{3}-?\\d{3}-?\\d{3}",
    country: "CA",
    description: null,
    entityType: "person",
    examples: ["123456782"],
    exportName: "sin",
    id: "ca.sin",
    lengths: [],
    localName: "Social Insurance Number",
    name: "Social Insurance Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ca",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.canada.ca/en/employment-social-development/services/sin.html",
    subpath: "ca/sin",
  },
  {
    abbreviation: "AHV",
    aliases: ["AHV-Nummer", "numéro AVS", "AVS", "AHV"],
    canGenerate: true,
    candidatePattern: "756\\.?\\d{4}\\.?\\d{4}\\.?\\d{2}",
    country: "CH",
    description: null,
    entityType: "person",
    examples: ["7561234567897"],
    exportName: "ssn",
    id: "ch.ssn",
    lengths: [],
    localName: "AHV-Versichertennummer",
    name: "Swiss Social Security Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ch",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.bsv.admin.ch/",
    subpath: "ch/ssn",
  },
  {
    abbreviation: "UID",
    aliases: [
      "Unternehmens-Identifikationsnummer",
      "UID",
      "IDE",
    ],
    canGenerate: true,
    candidatePattern: "CHE-?\\d{3}\\.?\\d{3}\\.?\\d{3}",
    country: "CH",
    description: null,
    entityType: "company",
    examples: ["CHE100155212"],
    exportName: "uid",
    id: "ch.uid",
    lengths: [],
    localName: "Unternehmens-Identifikationsnummer",
    name: "Swiss Business ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ch",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.uid.admin.ch/",
    subpath: "ch/uid",
  },
  {
    abbreviation: "MWST",
    aliases: ["MWST", "TVA", "IVA"],
    canGenerate: true,
    candidatePattern:
      "CHE-?\\d{3}\\.?\\d{3}\\.?\\d{3}\\s?(?:MWST|TVA|IVA)",
    country: "CH",
    description: null,
    entityType: "company",
    examples: ["CHE107787577IVA"],
    exportName: "vat",
    id: "ch.vat",
    lengths: [],
    localName: "Mehrwertsteuernummer",
    name: "Swiss VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ch",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.estv.admin.ch/",
    subpath: "ch/vat",
  },
  {
    abbreviation: "RUT",
    aliases: ["RUT", "Rol Único Tributario"],
    canGenerate: true,
    candidatePattern:
      "\\d{1,2}\\.?\\d{3}\\.?\\d{3}-?[\\dkK]",
    country: "CL",
    description: null,
    entityType: "any",
    examples: ["760864285", "125319092"],
    exportName: "rut",
    id: "cl.rut",
    lengths: [8, 9],
    localName: "Rol Único Tributario",
    name: "Chilean Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "cl",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.sii.cl/",
    subpath: "cl/rut",
  },
  {
    abbreviation: "RIC",
    aliases: ["身份证", "居民身份证号码", "RIC"],
    canGenerate: true,
    candidatePattern: "\\d{17}[\\dX]",
    country: "CN",
    description:
      "18-character national ID encoding area, birth date, gender, and check digit",
    entityType: "person",
    examples: ["11010519491231002X", "440524188001010014"],
    exportName: "ric",
    id: "cn.ric",
    lengths: [15, 18],
    localName: "居民身份证号码",
    name: "Chinese Resident Identity Card",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "cn",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Resident_Identity_Card",
    subpath: "cn/ric",
  },
  {
    abbreviation: "USCC",
    aliases: ["统一社会信用代码", "USCC"],
    canGenerate: true,
    candidatePattern:
      "[0-9A-HJ-NP-RTUW-Y]{2}\\d{6}[0-9A-HJ-NP-RTUW-Y]{10}",
    country: "CN",
    description:
      "18-character tax/registration code for Chinese entities",
    entityType: "company",
    examples: ["91110000600037341L"],
    exportName: "uscc",
    id: "cn.uscc",
    lengths: [18],
    localName: "统一社会信用代码",
    name: "Unified Social Credit Code",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "cn",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://zh.wikipedia.org/wiki/统一社会信用代码",
    subpath: "cn/uscc",
  },
  {
    abbreviation: "NIT",
    aliases: ["NIT", "Número de Identificación Tributaria"],
    canGenerate: true,
    candidatePattern: "\\d{9,10}-?\\d",
    country: "CO",
    description: "Tax identifier issued by the DIAN",
    entityType: "any",
    examples: ["2131234321", "8001234565"],
    exportName: "nit",
    id: "co.nit",
    lengths: [8, 9, 10, 11, 12, 13, 14, 15, 16],
    localName: "Número de Identificación Tributaria",
    name: "Número de Identificación Tributaria",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "co",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://es.wikipedia.org/wiki/N%C3%BAmero_de_identificaci%C3%B3n_tributaria",
    subpath: "co/nit",
  },
  {
    abbreviation: "CPF",
    aliases: ["CPF", "cédula de persona física"],
    canGenerate: true,
    candidatePattern: "\\d{9,12}",
    country: "CR",
    description: null,
    entityType: "person",
    examples: ["0304550175", "0109130259"],
    exportName: "cpf",
    id: "cr.cpf",
    lengths: [10],
    localName: "Cédula de Persona Física",
    name: "Costa Rican Physical Person ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "cr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.tse.go.cr/",
    subpath: "cr/cpf",
  },
  {
    abbreviation: "CC",
    aliases: [
      "credit card",
      "card number",
      "kreditní karta",
      "Kreditkarte",
    ],
    canGenerate: true,
    candidatePattern: "(?:\\d[\\s-]?){13,19}",
    country: null,
    description: null,
    entityType: "any",
    examples: ["4111111111111111", "5500000000000004"],
    exportName: "creditcard",
    id: "creditcard",
    lengths: [],
    localName: "Credit Card Number",
    name: "Credit Card Number",
    namedExports: [
      "compact",
      "detectNetwork",
      "format",
      "validate",
    ],
    namespaceExport: null,
    parseKind: null,
    scope: "global",
    sourceUrl: "https://www.iso.org/standard/70484.html",
    subpath: "creditcard",
  },
  {
    abbreviation: "BTC",
    aliases: [
      "Bitcoin address",
      "Bitcoin legacy address",
      "Base58Check address",
    ],
    canGenerate: false,
    candidatePattern: "[13][1-9A-HJ-NP-Za-km-z]{25,34}",
    country: null,
    description: null,
    entityType: "any",
    examples: [
      "1BoatSLRHtKNngkdXEeobR76b53LETtpyT",
      "3J98t1WpEZ73CNmQviecrnyiWrnqRhWNLy",
    ],
    exportName: "btcbase58",
    id: "crypto.btcbase58",
    lengths: [],
    localName: "Bitcoin Base58Check Address",
    name: "Bitcoin Base58Check Address",
    namedExports: [
      "compact",
      "decodeBase58",
      "format",
      "validate",
    ],
    namespaceExport: "crypto",
    parseKind: null,
    scope: "global",
    sourceUrl: null,
    subpath: "crypto/btcbase58",
  },
  {
    abbreviation: "BTC",
    aliases: [
      "Bitcoin address",
      "Bitcoin SegWit address",
      "Bech32 address",
      "Bech32m address",
    ],
    canGenerate: false,
    candidatePattern:
      "(?:bc1[ac-hj-np-z02-9]{11,71}|BC1[AC-HJ-NP-Z02-9]{11,71})",
    country: null,
    description: null,
    entityType: "any",
    examples: [
      "bc1qw508d6qejxtdg4y5r3zarvary0c5xw7kv8f3t4",
      "bc1qrp33g0q5c5txsp9arysrx4k6zdkfs4nce4xj0gdcccefvpysxf3qccfmv3",
    ],
    exportName: "btcbech32",
    id: "crypto.btcbech32",
    lengths: [],
    localName: "Bitcoin Bech32 Address",
    name: "Bitcoin Bech32 Address",
    namedExports: [
      "compact",
      "convertBits",
      "format",
      "polymod",
      "validate",
      "validateBech32",
    ],
    namespaceExport: "crypto",
    parseKind: null,
    scope: "global",
    sourceUrl: null,
    subpath: "crypto/btcbech32",
  },
  {
    abbreviation: "ETH",
    aliases: [
      "Ethereum address",
      "EVM address",
      "crypto wallet",
    ],
    canGenerate: false,
    candidatePattern: "0x[0-9A-Fa-f]{40}",
    country: null,
    description: null,
    entityType: "any",
    examples: [
      "0xde709f2102306220921060314715629080e2fb77",
    ],
    exportName: "eth",
    id: "crypto.eth",
    lengths: [42],
    localName: "Ethereum Address",
    name: "Ethereum Address",
    namedExports: [
      "compact",
      "format",
      "hasValidEip55Checksum",
      "validate",
    ],
    namespaceExport: "crypto",
    parseKind: null,
    scope: "global",
    sourceUrl: null,
    subpath: "crypto/eth",
  },
  {
    abbreviation: "crypto",
    aliases: [
      "crypto address",
      "wallet address",
      "cryptocurrency wallet",
    ],
    canGenerate: false,
    candidatePattern:
      "(?:0x[0-9A-Fa-f]{40}|[13][1-9A-HJ-NP-Za-km-z]{25,34}|bc1[ac-hj-np-z02-9]{11,71}|BC1[AC-HJ-NP-Z02-9]{11,71})",
    country: null,
    description: null,
    entityType: "any",
    examples: [
      "0xde709f2102306220921060314715629080e2fb77",
      "1BoatSLRHtKNngkdXEeobR76b53LETtpyT",
      "bc1qw508d6qejxtdg4y5r3zarvary0c5xw7kv8f3t4",
    ],
    exportName: "wallet",
    id: "crypto.wallet",
    lengths: [],
    localName: "Cryptocurrency Wallet Address",
    name: "Cryptocurrency Wallet Address",
    namedExports: ["compact", "format", "validate"],
    namespaceExport: "crypto",
    parseKind: null,
    scope: "global",
    sourceUrl: null,
    subpath: "crypto/wallet",
  },
  {
    abbreviation: "NI",
    aliases: [
      "NI",
      "número de identidad",
      "carnet de identidad",
    ],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "CU",
    description: null,
    entityType: "person",
    examples: ["91021027775", "72062506561"],
    exportName: "ni",
    id: "cu.ni",
    lengths: [11],
    localName: "Número de Identidad",
    name: "Cuban Identity Card Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "cu",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://www.ecured.cu/Carnet_de_Identidad",
    subpath: "cu/ni",
  },
  {
    abbreviation: "ΦΠΑ",
    aliases: ["ΦΠΑ", "VAT CY"],
    canGenerate: true,
    candidatePattern: "CY\\d{8}[A-Z]",
    country: "CY",
    description: null,
    entityType: "company",
    examples: ["10259033P"],
    exportName: "vat",
    id: "cy.vat",
    lengths: [],
    localName: "Αριθμός Εγγραφής Φ.Π.Α.",
    name: "Cypriot VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "cy",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.mof.gov.cy/",
    subpath: "cy/vat",
  },
  {
    abbreviation: "Číslo účtu",
    aliases: [
      "číslo účtu",
      "bankovní účet",
      "bankovní spojení",
    ],
    canGenerate: false,
    candidatePattern: "(?:\\d{1,6}-)?\\d{2,10}/\\d{4}",
    country: "CZ",
    description:
      "National-format account number with modulo-11 checks and a ČNB-assigned bank code",
    entityType: "any",
    examples: ["034278-0727558021/0100"],
    exportName: "bankaccount",
    id: "cz.bankaccount",
    lengths: [22],
    localName: "Číslo účtu v národním formátu",
    name: "Czech Bank Account Number",
    namedExports: ["compact", "format", "validate"],
    namespaceExport: "cz",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.cnb.cz/cs/platebni-styk/ucty-kody-bank/",
    subpath: "cz/bankaccount",
  },
  {
    abbreviation: "DIČ",
    aliases: ["DIČ", "daňové identifikační číslo"],
    canGenerate: true,
    candidatePattern: "CZ\\d{8,10}",
    country: "CZ",
    description: null,
    entityType: "any",
    examples: ["25123891", "7103192745"],
    exportName: "dic",
    id: "cz.dic",
    lengths: [8, 9, 10],
    localName: "Daňové identifikační číslo",
    name: "Czech VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "cz",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://adisspr.mfcr.cz/dpr/DphReg",
    subpath: "cz/dic",
  },
  {
    abbreviation: "IČO",
    aliases: ["IČO", "IČ", "identifikační číslo"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "CZ",
    description:
      "8-digit company ID assigned by the Czech Statistical Office",
    entityType: "company",
    examples: ["25123891", "27074358"],
    exportName: "ico",
    id: "cz.ico",
    lengths: [8],
    localName: "Identifikační číslo osoby",
    name: "Czech Company ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "cz",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.czso.cz/",
    subpath: "cz/ico",
  },
  {
    abbreviation: "RČ",
    aliases: ["rodné číslo", "RČ", "birth number"],
    canGenerate: true,
    candidatePattern: "\\d{6}/\\d{3,4}",
    country: "CZ",
    description:
      "Czech/Slovak national identifier encoding birth date and gender",
    entityType: "person",
    examples: ["7103192745"],
    exportName: "rc",
    id: "cz.rc",
    lengths: [9, 10],
    localName: "Rodné číslo",
    name: "Czech Birth Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "cz",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.mvcr.cz/mvcren/docDetail.aspx?docid=21975362&doctype=ART",
    subpath: "cz/rc",
  },
  {
    abbreviation: "HReg",
    aliases: [
      "Handelsregisternummer",
      "Handelsregister",
      "HRB",
      "HRA",
    ],
    canGenerate: true,
    candidatePattern: "(?:HRA|HRB|GnR|PR|VR)\\s*\\d{1,7}",
    country: "DE",
    description: null,
    entityType: "company",
    examples: ["HRB 12345"],
    exportName: "handelsreg",
    id: "de.handelsreg",
    lengths: [],
    localName: "Handelsregisternummer",
    name: "German Company Register Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "de",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://de.wikipedia.org/wiki/Handelsregister_(Deutschland)",
    subpath: "de/handelsreg",
  },
  {
    abbreviation: "IdNr",
    aliases: [
      "Steuerliche Identifikationsnummer",
      "IdNr",
      "Steuer-ID",
    ],
    canGenerate: true,
    candidatePattern:
      "\\d{2}\\s?\\d{3}\\s?\\d{3}\\s?\\d{3}",
    country: "DE",
    description: null,
    entityType: "person",
    examples: ["36574261809"],
    exportName: "idnr",
    id: "de.idnr",
    lengths: [],
    localName: "Steuerliche Identifikationsnummer",
    name: "German Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "de",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.bzst.de/DE/Privatpersonen/SteuerlicheIdentifikationsnummer/steuerlicheidentifikationsnummer_node.html",
    subpath: "de/idnr",
  },
  {
    abbreviation: "StNr",
    aliases: ["Steuernummer", "St.Nr."],
    canGenerate: true,
    candidatePattern: "\\d{2,4}/\\d{3,4}/\\d{4,5}",
    country: "DE",
    description:
      "German tax number assigned by the local tax office, varies by federal state",
    entityType: "any",
    examples: ["2181508150", "18181508155"],
    exportName: "stnr",
    id: "de.stnr",
    lengths: [10, 11, 13],
    localName: "Steuernummer",
    name: "German Tax Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "de",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://de.wikipedia.org/wiki/Steuernummer",
    subpath: "de/stnr",
  },
  {
    abbreviation: "SVNR",
    aliases: [
      "Sozialversicherungsnummer",
      "SVNR",
      "Versicherungsnummer",
    ],
    canGenerate: true,
    candidatePattern: "\\d{2}\\s?\\d{6}\\s?[A-Z]\\s?\\d{3}",
    country: "DE",
    description:
      "German social insurance number encoding birth date and name initial",
    entityType: "person",
    examples: ["12010188M011"],
    exportName: "svnr",
    id: "de.svnr",
    lengths: [12],
    localName: "Sozialversicherungsnummer",
    name: "German Social Insurance Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "de",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://de.wikipedia.org/wiki/Sozialversicherungsnummer",
    subpath: "de/svnr",
  },
  {
    abbreviation: "USt-IdNr.",
    aliases: [
      "USt-IdNr",
      "Umsatzsteuer-Identifikationsnummer",
      "VAT DE",
    ],
    canGenerate: true,
    candidatePattern: "DE\\d{9}",
    country: "DE",
    description:
      "German VAT ID issued by the Federal Tax Office (BZSt)",
    entityType: "company",
    examples: ["136695976"],
    exportName: "vat",
    id: "de.vat",
    lengths: [9],
    localName: "Umsatzsteuer-Identifikationsnummer",
    name: "German VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "de",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.bzst.de/DE/Unternehmen/Identifikationsnummern/Umsatzsteuer-Identifikationsnummer/umsatzsteuer-identifikationsnummer_node.html",
    subpath: "de/vat",
  },
  {
    abbreviation: "CPR",
    aliases: ["CPR-nummer", "personnummer", "CPR"],
    canGenerate: true,
    candidatePattern: "\\d{6}-?\\d{4}",
    country: "DK",
    description: null,
    entityType: "person",
    examples: ["2110625629"],
    exportName: "cpr",
    id: "dk.cpr",
    lengths: [10],
    localName: "Det Centrale Personregister",
    name: "Danish Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "dk",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://cpr.dk/",
    subpath: "dk/cpr",
  },
  {
    abbreviation: "CVR",
    aliases: ["CVR-nummer", "CVR"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "DK",
    description: null,
    entityType: "company",
    examples: ["13585628"],
    exportName: "cvr",
    id: "dk.cvr",
    lengths: [],
    localName: "CVR-nummer",
    name: "Danish Business Register Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "dk",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://erhvervsstyrelsen.dk/",
    subpath: "dk/cvr",
  },
  {
    abbreviation: "CVR",
    aliases: ["momsnummer", "SE-nummer"],
    canGenerate: true,
    candidatePattern: "DK\\d{8}",
    country: "DK",
    description: null,
    entityType: "company",
    examples: ["13585628"],
    exportName: "vat",
    id: "dk.vat",
    lengths: [8],
    localName: "Momsregistreringsnummer",
    name: "Danish VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "dk",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://erhvervsstyrelsen.dk/",
    subpath: "dk/vat",
  },
  {
    abbreviation: "RNC",
    aliases: ["RNC", "Registro Nacional del Contribuyente"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "DO",
    description: null,
    entityType: "any",
    examples: ["131098193", "00113918205"],
    exportName: "rnc",
    id: "do.rnc",
    lengths: [9, 11],
    localName: "Registro Nacional del Contribuyente",
    name: "Dominican Republic Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "do_",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://dgii.gov.do/",
    subpath: "do/rnc",
  },
  {
    abbreviation: "RUC",
    aliases: ["RUC", "Registro Único de Contribuyentes"],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "EC",
    description:
      "13-digit tax identification number issued by the SRI",
    entityType: "any",
    examples: ["1792060346001", "1790011674001"],
    exportName: "ruc",
    id: "ec.ruc",
    lengths: [13],
    localName: "Registro Único de Contribuyentes",
    name: "Registro Único de Contribuyentes",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ec",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.sri.gob.ec/",
    subpath: "ec/ruc",
  },
  {
    abbreviation: "IK",
    aliases: ["isikukood", "IK"],
    canGenerate: true,
    candidatePattern: "[1-6]\\d{10}",
    country: "EE",
    description: null,
    entityType: "person",
    examples: ["36805280109"],
    exportName: "ik",
    id: "ee.ik",
    lengths: [],
    localName: "Isikukood",
    name: "Estonian Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "twoPassCheck",
      "validate",
    ],
    namespaceExport: "ee",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.riigiteataja.ee/en/eli/512012015003/consolide",
    subpath: "ee/ik",
  },
  {
    abbreviation: "Registrikood",
    aliases: ["registrikood"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "EE",
    description: null,
    entityType: "company",
    examples: ["12345678"],
    exportName: "registrikood",
    id: "ee.registrikood",
    lengths: [],
    localName: "Registrikood",
    name: "Estonian Company Registration Code",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ee",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.rik.ee/",
    subpath: "ee/registrikood",
  },
  {
    abbreviation: "KMKR",
    aliases: ["käibemaksukohustuslase number", "KMKR"],
    canGenerate: true,
    candidatePattern: "EE\\d{9}",
    country: "EE",
    description: null,
    entityType: "company",
    examples: ["100931558"],
    exportName: "vat",
    id: "ee.vat",
    lengths: [],
    localName: "Käibemaksukohustuslase number",
    name: "Estonian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ee",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.emta.ee/en",
    subpath: "ee/vat",
  },
  {
    abbreviation: "TN",
    aliases: ["الرقم الضريبي", "tax number"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "EG",
    description: "Egyptian tax identification number",
    entityType: "any",
    examples: ["100531385", "331105268"],
    exportName: "tn",
    id: "eg.tn",
    lengths: [9],
    localName: "الرقم الضريبي",
    name: "Egyptian Tax Registration Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "eg",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.eta.gov.eg/",
    subpath: "eg/tn",
  },
  {
    abbreviation: "CIF",
    aliases: ["CIF", "código de identificación fiscal"],
    canGenerate: true,
    candidatePattern: "[A-HJNP-SUVW]\\d{7}[\\dA-J]",
    country: "ES",
    description: null,
    entityType: "company",
    examples: ["A13585625"],
    exportName: "cif",
    id: "es.cif",
    lengths: [],
    localName: "Código de Identificación Fiscal",
    name: "Spanish Company Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "es",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.agenciatributaria.es/",
    subpath: "es/cif",
  },
  {
    abbreviation: "DNI",
    aliases: [
      "D.N.I.",
      "DNI",
      "documento nacional de identidad",
    ],
    canGenerate: true,
    candidatePattern: "\\d{1,2}\\.?\\d{3}\\.?\\d{3}-?[A-Z]",
    country: "ES",
    description: null,
    entityType: "person",
    examples: ["54362315K", "1234567L"],
    exportName: "dni",
    id: "es.dni",
    lengths: [2, 3, 4, 5, 6, 7, 8, 9],
    localName: "Documento Nacional de Identidad",
    name: "Spanish National ID",
    namedExports: [
      "CHECK_LETTERS",
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "es",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.interior.gob.es/opencms/es/servicios-al-ciudadano/tramites-y-gestiones/dni/",
    subpath: "es/dni",
  },
  {
    abbreviation: "NIE",
    aliases: [
      "N.I.E.",
      "NIE",
      "número de identidad de extranjero",
    ],
    canGenerate: true,
    candidatePattern: "[XYZ]-?\\d{7}-?[A-Z]",
    country: "ES",
    description: null,
    entityType: "person",
    examples: ["X5253868R"],
    exportName: "nie",
    id: "es.nie",
    lengths: [],
    localName: "Número de Identidad de Extranjero",
    name: "Spanish Foreigner ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "es",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.interior.gob.es/opencms/es/servicios-al-ciudadano/tramites-y-gestiones/nie/",
    subpath: "es/nie",
  },
  {
    abbreviation: "NSS",
    aliases: ["NSS", "número de seguridad social"],
    canGenerate: true,
    candidatePattern: "\\d{12}",
    country: "ES",
    description:
      "Spanish Social Security affiliation number with mod-97 check digits",
    entityType: "person",
    examples: ["281234567840"],
    exportName: "nss",
    id: "es.nss",
    lengths: [12],
    localName: "Número de la Seguridad Social",
    name: "Spanish Social Security Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "es",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.seg-social.es/",
    subpath: "es/nss",
  },
  {
    abbreviation: "NIF",
    aliases: [
      "NIF",
      "CIF",
      "número de identificación fiscal",
    ],
    canGenerate: true,
    candidatePattern: "ES[A-Z]\\d{7}[A-Z\\d]",
    country: "ES",
    description: null,
    entityType: "any",
    examples: ["12345678Z", "A78304516"],
    exportName: "vat",
    id: "es.vat",
    lengths: [],
    localName: "Número de Identificación Fiscal",
    name: "Spanish VAT Number",
    namedExports: [
      "cifChecksum",
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "es",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.agenciatributaria.es/",
    subpath: "es/vat",
  },
  {
    abbreviation: "EU VAT",
    aliases: ["EU VAT", "VAT identification number"],
    canGenerate: true,
    candidatePattern: "[A-Z]{2}\\d{8,12}",
    country: null,
    description: null,
    entityType: "company",
    examples: ["ATU13585627", "DE136695976"],
    exportName: "vat",
    id: "eu.vat",
    lengths: [],
    localName: "EU VAT Number",
    name: "EU VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "eu",
    parseKind: null,
    scope: "global",
    sourceUrl:
      "https://ec.europa.eu/taxation_customs/vies/",
    subpath: "eu/vat",
  },
  {
    abbreviation: "HETU",
    aliases: [
      "henkilötunnus",
      "HETU",
      "sosiaaliturvatunnus",
    ],
    canGenerate: true,
    candidatePattern: "\\d{6}[-+A]\\d{3}[\\dA-Z]",
    country: "FI",
    description: null,
    entityType: "person",
    examples: ["131052-308T"],
    exportName: "hetu",
    id: "fi.hetu",
    lengths: [11],
    localName: "Henkilötunnus",
    name: "Finnish Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "fi",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://dvv.fi/en/personal-identity-code",
    subpath: "fi/hetu",
  },
  {
    abbreviation: "ALV nro",
    aliases: ["ALV-numero", "Y-tunnus"],
    canGenerate: true,
    candidatePattern: "FI\\d{8}",
    country: "FI",
    description: null,
    entityType: "company",
    examples: ["20774740"],
    exportName: "vat",
    id: "fi.vat",
    lengths: [8],
    localName: "Arvonlisäveronumero",
    name: "Finnish VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "fi",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.ytj.fi/en/index/businessid.html",
    subpath: "fi/vat",
  },
  {
    abbreviation: "Y-tunnus",
    aliases: ["Y-tunnus", "yritystunnus", "FO-nummer"],
    canGenerate: true,
    candidatePattern: "\\d{7}-\\d",
    country: "FI",
    description: null,
    entityType: "company",
    examples: ["20774740"],
    exportName: "ytunnus",
    id: "fi.ytunnus",
    lengths: [],
    localName: "Y-tunnus",
    name: "Finnish Business ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "fi",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.ytj.fi/en/index/businessid.html",
    subpath: "fi/ytunnus",
  },
  {
    abbreviation: "NIF",
    aliases: [
      "numéro fiscal",
      "NIF",
      "numéro d'identification fiscale",
    ],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "FR",
    description: null,
    entityType: "person",
    examples: ["3023217600053"],
    exportName: "nif",
    id: "fr.nif",
    lengths: [],
    localName: "Numéro d'Identification Fiscale",
    name: "French Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "fr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.impots.gouv.fr/",
    subpath: "fr/nif",
  },
  {
    abbreviation: "NIR",
    aliases: [
      "NIR",
      "numéro de sécurité sociale",
      "numéro SS",
      "sécu",
    ],
    canGenerate: true,
    candidatePattern:
      "[12]\\s?\\d{2}\\s?\\d{2}\\s?\\d{2}\\s?\\d{3}\\s?\\d{3}\\s?\\d{2}",
    country: "FR",
    description:
      "French social security number encoding gender, birth date, and department",
    entityType: "person",
    examples: ["295117823456784"],
    exportName: "nir",
    id: "fr.nir",
    lengths: [15],
    localName: "Numero d'Inscription au Repertoire",
    name: "French Social Security Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "fr",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://en.wikipedia.org/wiki/INSEE_code",
    subpath: "fr/nir",
  },
  {
    abbreviation: "SIREN",
    aliases: ["SIREN", "numéro SIREN"],
    canGenerate: true,
    candidatePattern: "\\d{3}\\s?\\d{3}\\s?\\d{3}",
    country: "FR",
    description: null,
    entityType: "company",
    examples: ["552008443"],
    exportName: "siren",
    id: "fr.siren",
    lengths: [],
    localName:
      "Système d'Identification du Répertoire des Entreprises",
    name: "French Company ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "fr",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.insee.fr/fr/information/2549588",
    subpath: "fr/siren",
  },
  {
    abbreviation: "SIRET",
    aliases: ["SIRET", "numéro SIRET"],
    canGenerate: true,
    candidatePattern:
      "\\d{3}\\s?\\d{3}\\s?\\d{3}\\s?\\d{5}",
    country: "FR",
    description: null,
    entityType: "company",
    examples: ["73282932000074"],
    exportName: "siret",
    id: "fr.siret",
    lengths: [],
    localName:
      "Système d'Identification du Répertoire des Établissements",
    name: "French Establishment ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "fr",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.insee.fr/fr/information/2549588",
    subpath: "fr/siret",
  },
  {
    abbreviation: "TVA",
    aliases: [
      "numéro de TVA",
      "TVA intracommunautaire",
      "FR VAT",
    ],
    canGenerate: true,
    candidatePattern: "FR[A-Z0-9]{2}\\d{9}",
    country: "FR",
    description: null,
    entityType: "company",
    examples: ["40303265045", "K7399859412"],
    exportName: "tva",
    id: "fr.tva",
    lengths: [],
    localName: "Numéro de TVA intracommunautaire",
    name: "French VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "fr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.economie.gouv.fr/",
    subpath: "fr/tva",
  },
  {
    abbreviation: "NHS",
    aliases: [
      "NHS number",
      "National Health Service number",
    ],
    canGenerate: false,
    candidatePattern: "\\d{3}\\s?\\d{3}\\s?\\d{4}",
    country: "GB",
    description: null,
    entityType: "person",
    examples: ["4010232137"],
    exportName: "nhs",
    id: "gb.nhs",
    lengths: [10],
    localName: "NHS number",
    name: "UK NHS Number",
    namedExports: [
      "calcCheckDigit",
      "compact",
      "format",
      "validate",
    ],
    namespaceExport: "gb",
    parseKind: null,
    scope: "country",
    sourceUrl: null,
    subpath: "gb/nhs",
  },
  {
    abbreviation: "NINO",
    aliases: [
      "National Insurance number",
      "NINO",
      "NI number",
    ],
    canGenerate: true,
    candidatePattern: "[A-Z]{2}\\d{6}[A-Z]",
    country: "GB",
    description:
      "UK National Insurance Number for tax and benefits",
    entityType: "person",
    examples: ["AB123456C"],
    exportName: "nino",
    id: "gb.nino",
    lengths: [9],
    localName: "National Insurance Number",
    name: "UK National Insurance Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gb",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.gov.uk/hmrc-internal-manuals/national-insurance-manual/nim39110",
    subpath: "gb/nino",
  },
  {
    abbreviation: "SEDOL",
    aliases: [
      "SEDOL",
      "Stock Exchange Daily Official List",
    ],
    canGenerate: true,
    candidatePattern: "[B-DF-HJ-NP-TV-Z0-9]{6}\\d",
    country: "GB",
    description: null,
    entityType: "any",
    examples: ["B15KXQ8"],
    exportName: "sedol",
    id: "gb.sedol",
    lengths: [7],
    localName: "Stock Exchange Daily Official List number",
    name: "Stock Exchange Daily Official List number",
    namedExports: [
      "calcCheckDigit",
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gb",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://en.wikipedia.org/wiki/SEDOL",
    subpath: "gb/sedol",
  },
  {
    abbreviation: "UTR",
    aliases: ["Unique Taxpayer Reference", "UTR"],
    canGenerate: true,
    candidatePattern: "\\d{10}",
    country: "GB",
    description: null,
    entityType: "any",
    examples: ["1955839661"],
    exportName: "utr",
    id: "gb.utr",
    lengths: [],
    localName: "Unique Taxpayer Reference",
    name: "UK Unique Taxpayer Reference",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gb",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.gov.uk/find-utr-number",
    subpath: "gb/utr",
  },
  {
    abbreviation: "VAT",
    aliases: ["VAT registration number", "VAT number"],
    canGenerate: true,
    candidatePattern: "GB\\d{9,12}",
    country: "GB",
    description: null,
    entityType: "company",
    examples: ["980780684"],
    exportName: "vat",
    id: "gb.vat",
    lengths: [],
    localName: "VAT Registration Number",
    name: "UK VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gb",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.gov.uk/vat-registration",
    subpath: "gb/vat",
  },
  {
    abbreviation: "PIN",
    aliases: ["პირადი ნომერი", "PIN"],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "GE",
    description: null,
    entityType: "any",
    examples: ["010043120", "01024030303"],
    exportName: "pin",
    id: "ge.pin",
    lengths: [9, 11],
    localName: "პირადი ნომერი",
    name: "Georgian Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ge",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Georgia-TIN.pdf",
    subpath: "ge/pin",
  },
  {
    abbreviation: "TIN",
    aliases: ["TIN", "Tax Identification Number"],
    canGenerate: true,
    candidatePattern: "[A-Z]\\d{9,10}",
    country: "GH",
    description: "Ghanaian tax identification number",
    entityType: "any",
    examples: ["C0000803561"],
    exportName: "tin",
    id: "gh.tin",
    lengths: [11],
    localName: "Tax Identification Number",
    name: "Ghanaian Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gh",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://gra.gov.gh/",
    subpath: "gh/tin",
  },
  {
    abbreviation: "ΑΜΚΑ",
    aliases: [
      "ΑΜΚΑ",
      "Αριθμός Μητρώου Κοινωνικής Ασφάλισης",
      "AMKA",
    ],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "GR",
    description: null,
    entityType: "person",
    examples: ["01013099997"],
    exportName: "amka",
    id: "gr.amka",
    lengths: [],
    localName: "Αριθμός Μητρώου Κοινωνικής Ασφάλισης",
    name: "Greek Social Security Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.amka.gr/",
    subpath: "gr/amka",
  },
  {
    abbreviation: "ΑΦΜ",
    aliases: ["ΑΦΜ", "Αριθμός Φορολογικού Μητρώου", "AFM"],
    canGenerate: true,
    candidatePattern: "EL\\d{9}",
    country: "GR",
    description: null,
    entityType: "any",
    examples: ["094259216"],
    exportName: "vat",
    id: "gr.vat",
    lengths: [],
    localName: "Αριθμός Φορολογικού Μητρώου",
    name: "Greek VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.aade.gr/",
    subpath: "gr/vat",
  },
  {
    abbreviation: "NIT",
    aliases: ["NIT"],
    canGenerate: true,
    candidatePattern: "\\d{7,8}-?\\d",
    country: "GT",
    description: "Tax identifier issued by Guatemala's SAT",
    entityType: "any",
    examples: ["576937K", "39525503", "71080"],
    exportName: "nit",
    id: "gt.nit",
    lengths: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    localName: "Número de Identificación Tributaria",
    name: "Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "gt",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://portal.sat.gob.gt/portal/",
    subpath: "gt/nit",
  },
  {
    abbreviation: "HKID",
    aliases: ["HKID", "香港身份證"],
    canGenerate: true,
    candidatePattern: "[A-Z]{1,2}\\d{6}[\\dA]",
    country: "HK",
    description:
      "Identity card number issued by the Hong Kong Immigration Department",
    entityType: "person",
    examples: ["G123456A", "AB9876543"],
    exportName: "hkid",
    id: "hk.hkid",
    lengths: [8, 9],
    localName: "Hong Kong Identity Card Number",
    name: "Hong Kong Identity Card Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "hk",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Hong_Kong_identity_card",
    subpath: "hk/hkid",
  },
  {
    abbreviation: "OIB",
    aliases: ["OIB", "osobni identifikacijski broj"],
    canGenerate: true,
    candidatePattern: "HR\\d{11}",
    country: "HR",
    description: null,
    entityType: "any",
    examples: ["33392005961"],
    exportName: "vat",
    id: "hr.vat",
    lengths: [],
    localName: "Osobni identifikacijski broj",
    name: "Croatian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "hr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.porezna-uprava.hr/",
    subpath: "hr/vat",
  },
  {
    abbreviation: "ANUM",
    aliases: ["adószám", "adóazonosító jel"],
    canGenerate: true,
    candidatePattern: "\\d{8}-\\d-\\d{2}",
    country: "HU",
    description: null,
    entityType: "company",
    examples: ["12892312"],
    exportName: "vat",
    id: "hu.vat",
    lengths: [8],
    localName: "Adószám",
    name: "Hungarian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "hu",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://nav.gov.hu/",
    subpath: "hu/vat",
  },
  {
    abbreviation: "IBAN",
    aliases: ["IBAN"],
    canGenerate: true,
    candidatePattern:
      "[A-Z]{2}\\d{2}[\\s]?[A-Z0-9]{4}[\\s]?(?:[A-Z0-9]{4}[\\s]?){2,7}[A-Z0-9]{1,4}",
    country: null,
    description:
      "International bank account number per ISO 13616",
    entityType: "any",
    examples: [
      "GB29NWBK60161331926819",
      "DE89370400440532013000",
    ],
    exportName: "iban",
    id: "iban",
    lengths: [],
    localName: "IBAN",
    name: "IBAN",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: null,
    parseKind: null,
    scope: "global",
    sourceUrl:
      "https://www.swift.com/standards/data-standards/iban-international-bank-account-number",
    subpath: "iban",
  },
  {
    abbreviation: "NPWP",
    aliases: ["NPWP", "Nomor Pokok Wajib Pajak"],
    canGenerate: true,
    candidatePattern:
      "\\d{2}\\.?\\d{3}\\.?\\d{3}\\.?\\d-?\\d{3}\\.?\\d{3}",
    country: "ID",
    description:
      "15 or 16-digit tax identification number issued by the Directorate General of Taxes",
    entityType: "any",
    examples: ["013000666091000", "016090524017000"],
    exportName: "npwp",
    id: "id.npwp",
    lengths: [15, 16],
    localName: "Nomor Pokok Wajib Pajak",
    name: "Indonesian Taxpayer Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "id",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Tax_identification_number#Indonesia",
    subpath: "id/npwp",
  },
  {
    abbreviation: "PPS",
    aliases: ["PPS number", "PPSN", "RSI number"],
    canGenerate: true,
    candidatePattern: "\\d{7}[A-Z]{1,2}",
    country: "IE",
    description: null,
    entityType: "person",
    examples: ["6433435F"],
    exportName: "pps",
    id: "ie.pps",
    lengths: [],
    localName: "Personal Public Service Number",
    name: "Irish Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ie",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.gov.ie/en/service/12e6de-get-a-personal-public-service-pps-number/",
    subpath: "ie/pps",
  },
  {
    abbreviation: "VAT",
    aliases: ["VAT number IE"],
    canGenerate: true,
    candidatePattern: "IE\\d[A-Z+*]\\d{5}[A-Z]",
    country: "IE",
    description: null,
    entityType: "any",
    examples: ["6433435F", "8D79739I"],
    exportName: "vat",
    id: "ie.vat",
    lengths: [],
    localName: "Value Added Tax Number",
    name: "Irish VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ie",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.revenue.ie/",
    subpath: "ie/vat",
  },
  {
    abbreviation: "ת.ז.",
    aliases: ["תעודת זהות", "Teudat Zehut", "ID number"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "IL",
    description:
      "Israeli personal identification number (Mispar Zehut)",
    entityType: "person",
    examples: ["039337423", "000000018"],
    exportName: "idnr",
    id: "il.idnr",
    lengths: [9],
    localName: "מספר זהות",
    name: "Israeli Identity Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "il",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Israeli_identity_card",
    subpath: "il/idnr",
  },
  {
    abbreviation: "Aadhaar",
    aliases: ["Aadhaar", "आधार"],
    canGenerate: true,
    candidatePattern: "\\d{4}\\s?\\d{4}\\s?\\d{4}",
    country: "IN",
    description:
      "12-digit unique identity number issued by UIDAI",
    entityType: "person",
    examples: ["234123412346", "295274982189"],
    exportName: "aadhaar",
    id: "in.aadhaar",
    lengths: [12],
    localName: "Aadhaar",
    name: "Indian Unique Identity Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "in_",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://uidai.gov.in/",
    subpath: "in/aadhaar",
  },
  {
    abbreviation: "GSTIN",
    aliases: ["GSTIN", "GST number"],
    canGenerate: true,
    candidatePattern:
      "\\d{2}[A-Z]{5}\\d{4}[A-Z][A-Z\\d][Z][A-Z\\d]",
    country: "IN",
    description:
      "15-character tax identifier for GST-registered businesses",
    entityType: "company",
    examples: ["27AAPFU0939F1ZV", "29AAGCB7383J1Z4"],
    exportName: "gstin",
    id: "in.gstin",
    lengths: [15],
    localName:
      "Goods and Services Tax Identification Number",
    name: "Indian Goods and Services Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "in_",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Goods_and_Services_Tax_Identification_Number",
    subpath: "in/gstin",
  },
  {
    abbreviation: "PAN",
    aliases: ["PAN", "Permanent Account Number"],
    canGenerate: true,
    candidatePattern: "[A-Z]{5}\\d{4}[A-Z]",
    country: "IN",
    description: "10-character alphanumeric tax identifier",
    entityType: "any",
    examples: ["ABCPP1234C", "AAACR5055K"],
    exportName: "pan",
    id: "in.pan",
    lengths: [10],
    localName: "Permanent Account Number",
    name: "Indian Permanent Account Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "in_",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Permanent_account_number",
    subpath: "in/pan",
  },
  {
    abbreviation: "NID",
    aliases: ["NID", "البطاقة الوطنية الموحدة"],
    canGenerate: true,
    candidatePattern: "\\d{12}",
    country: "IQ",
    description:
      "Iraqi personal identification number (National Card)",
    entityType: "person",
    examples: ["012345678901"],
    exportName: "nid",
    id: "iq.nid",
    lengths: [12],
    localName: "البطاقة الوطنية الموحدة",
    name: "Iraqi National ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "iq",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://mofa.gov.iq/the-civil-status-id/",
    subpath: "iq/nid",
  },
  {
    abbreviation: "NID",
    aliases: ["NID", "کد ملی", "national code"],
    canGenerate: true,
    candidatePattern: "\\d{10}",
    country: "IR",
    description:
      "Iranian personal identification number (Code Melli)",
    entityType: "person",
    examples: ["0932833810"],
    exportName: "nid",
    id: "ir.nid",
    lengths: [10],
    localName: "کد ملی",
    name: "Iranian National ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ir",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.sabteahval.ir/",
    subpath: "ir/nid",
  },
  {
    abbreviation: "kt.",
    aliases: ["kennitala", "kt."],
    canGenerate: true,
    candidatePattern: "\\d{6}-?\\d{4}",
    country: "IS",
    description: null,
    entityType: "any",
    examples: ["4504013150", "1201743399"],
    exportName: "kennitala",
    id: "is.kennitala",
    lengths: [],
    localName: "Kennitala",
    name: "Icelandic ID Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "is_",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.skra.is/",
    subpath: "is/kennitala",
  },
  {
    abbreviation: "VSK",
    aliases: ["VSK-númer", "virðisaukaskattur"],
    canGenerate: true,
    candidatePattern: "IS\\d{5,6}",
    country: "IS",
    description: null,
    entityType: "company",
    examples: ["00621", "123456"],
    exportName: "vsk",
    id: "is.vsk",
    lengths: [],
    localName: "Virðisaukaskattur",
    name: "Icelandic VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "is_",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.rsk.is/",
    subpath: "is/vsk",
  },
  {
    abbreviation: "ISIN",
    aliases: [
      "ISIN",
      "International Securities Identification Number",
    ],
    canGenerate: true,
    candidatePattern: "[A-Z]{2}[A-Z0-9]{9}\\d",
    country: null,
    description: null,
    entityType: "any",
    examples: ["US0378331005", "GB0002634946"],
    exportName: "isin",
    id: "isin",
    lengths: [],
    localName:
      "International Securities Identification Number",
    name: "International Securities Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: null,
    parseKind: null,
    scope: "global",
    sourceUrl: "https://www.isin.org/",
    subpath: "isin",
  },
  {
    abbreviation: "CF",
    aliases: [
      "codice fiscale",
      "C.F.",
      "CF",
      "cod. fisc.",
      "fiscal code",
    ],
    canGenerate: true,
    candidatePattern:
      "[A-Z]{6}\\d{2}[A-Z]\\d{2}[A-Z]\\d{3}[A-Z]",
    country: "IT",
    description:
      "Personal/company tax code (16-char personal, 11-digit company)",
    entityType: "person",
    examples: ["RCCMNL83S18D969H"],
    exportName: "codiceFiscale",
    id: "it.codiceFiscale",
    lengths: [11, 16],
    localName: "Codice Fiscale",
    name: "Italian Tax Code",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "it",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://www.agenziaentrate.gov.it/",
    subpath: "it/codicefiscale",
  },
  {
    abbreviation: "P.IVA",
    aliases: ["partita IVA", "P.IVA", "P. IVA", "VAT IT"],
    canGenerate: true,
    candidatePattern: "IT\\d{11}",
    country: "IT",
    description: null,
    entityType: "company",
    examples: ["00743110157"],
    exportName: "iva",
    id: "it.iva",
    lengths: [],
    localName: "Partita IVA",
    name: "Italian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "it",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.agenziaentrate.gov.it/",
    subpath: "it/iva",
  },
  {
    abbreviation: "CN",
    aliases: ["法人番号", "Corporate Number"],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "JP",
    description:
      "13-digit corporate identifier assigned by the National Tax Agency",
    entityType: "company",
    examples: ["5835678256246", "2021001052596"],
    exportName: "cn",
    id: "jp.cn",
    lengths: [13],
    localName: "法人番号",
    name: "Japanese Corporate Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "jp",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Corporate_Number_(Japan)",
    subpath: "jp/cn",
  },
  {
    abbreviation: "My Number",
    aliases: ["My Number", "マイナンバー", "個人番号"],
    canGenerate: true,
    candidatePattern: "\\d{4}[\\s-]?\\d{4}[\\s-]?\\d{4}",
    country: "JP",
    description:
      "12-digit personal identifier for tax and social security",
    entityType: "person",
    examples: ["123456789018", "000000000019"],
    exportName: "mynumber",
    id: "jp.mynumber",
    lengths: [12],
    localName: "マイナンバー",
    name: "Japanese Individual Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "jp",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Individual_Number",
    subpath: "jp/mynumber",
  },
  {
    abbreviation: "BRN",
    aliases: ["사업자등록번호", "BRN"],
    canGenerate: true,
    candidatePattern: "\\d{3}-?\\d{2}-?\\d{5}",
    country: "KR",
    description:
      "10-digit business identifier issued by the National Tax Service",
    entityType: "company",
    examples: ["1168200131", "2208162517"],
    exportName: "brn",
    id: "kr.brn",
    lengths: [10],
    localName: "사업자등록번호",
    name: "Korean Business Registration Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "kr",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Business_registration_number_(South_Korea)",
    subpath: "kr/brn",
  },
  {
    abbreviation: "RRN",
    aliases: [
      "RRN",
      "주민등록번호",
      "Resident Registration Number",
    ],
    canGenerate: true,
    candidatePattern: "\\d{6}[\\s-]?\\d{7}",
    country: "KR",
    description:
      "13-digit personal identifier issued to all residents of South Korea",
    entityType: "person",
    examples: ["9710139019902", "9501011000109"],
    exportName: "rrn",
    id: "kr.rrn",
    lengths: [13],
    localName: "주민등록번호",
    name: "Korean Resident Registration Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "kr",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Resident_registration_number",
    subpath: "kr/rrn",
  },
  {
    abbreviation: "Civil ID",
    aliases: ["Civil ID", "الرقم المدني"],
    canGenerate: true,
    candidatePattern: "\\d{12}",
    country: "KW",
    description:
      "12-digit civil identification number issued by PACI",
    entityType: "person",
    examples: ["289011200032", "305031512348"],
    exportName: "civil",
    id: "kw.civil",
    lengths: [12],
    localName: "الرقم المدني",
    name: "Civil Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "kw",
    parseKind: "birthDate",
    scope: "country",
    sourceUrl:
      "https://kuwaitsexpat.com/kuwait-civil-id-format/",
    subpath: "kw/civil",
  },
  {
    abbreviation: "IIN",
    aliases: [
      "ИИН",
      "IIN",
      "индивидуальный идентификационный номер",
    ],
    canGenerate: true,
    candidatePattern: "\\d{12}",
    country: "KZ",
    description: null,
    entityType: "person",
    examples: ["880515300120", "950101400012"],
    exportName: "iin",
    id: "kz.iin",
    lengths: [12],
    localName: "Жеке сәйкестендіру нөмірі",
    name: "Kazakhstan Individual ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "kz",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Kazakhstan-TIN.pdf",
    subpath: "kz/iin",
  },
  {
    abbreviation: "LEI",
    aliases: ["LEI", "Legal Entity Identifier"],
    canGenerate: true,
    candidatePattern: "[A-Z0-9]{18}\\d{2}",
    country: null,
    description: null,
    entityType: "company",
    examples: ["5493006MHB84DD0ZWV18"],
    exportName: "lei",
    id: "lei",
    lengths: [],
    localName: "Legal Entity Identifier",
    name: "Legal Entity Identifier",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: null,
    parseKind: null,
    scope: "global",
    sourceUrl: "https://www.gleif.org/",
    subpath: "lei",
  },
  {
    abbreviation: "PEID",
    aliases: ["PEID", "Personenidentifikation"],
    canGenerate: true,
    candidatePattern: "\\d{6}",
    country: "LI",
    description: null,
    entityType: "any",
    examples: ["1234567"],
    exportName: "peid",
    id: "li.peid",
    lengths: [4, 5, 6, 7, 8, 9, 10, 11, 12],
    localName: "Personenidentifikationsnummer",
    name: "Liechtenstein Person Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "li",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.oera.li/",
    subpath: "li/peid",
  },
  {
    abbreviation: "NIC",
    aliases: ["NIC", "ජාතික හැඳුනුම්පත"],
    canGenerate: true,
    candidatePattern: "\\d{9}[VXvx]|\\d{12}",
    country: "LK",
    description:
      "Sri Lankan personal identity number issued to all citizens",
    entityType: "person",
    examples: ["197819202757", "862348753V"],
    exportName: "nic",
    id: "lk.nic",
    lengths: [10, 12],
    localName: "ජාතික හැඳුනුම්පත",
    name: "National Identity Card",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "lk",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/National_identification_number#Sri_Lanka",
    subpath: "lk/nic",
  },
  {
    abbreviation: "AK",
    aliases: ["asmens kodas", "AK"],
    canGenerate: true,
    candidatePattern: "[3-6]\\d{10}",
    country: "LT",
    description: null,
    entityType: "person",
    examples: ["33309240064"],
    exportName: "asmens",
    id: "lt.asmens",
    lengths: [],
    localName: "Asmens kodas",
    name: "Lithuanian Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "lt",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.registrucentras.lt/",
    subpath: "lt/asmens",
  },
  {
    abbreviation: "PVM kodas",
    aliases: ["PVM mokėtojo kodas", "PVM"],
    canGenerate: true,
    candidatePattern: "LT\\d{9,12}",
    country: "LT",
    description: null,
    entityType: "any",
    examples: ["119511515", "100001919017"],
    exportName: "vat",
    id: "lt.vat",
    lengths: [9, 12],
    localName: "PVM mokėtojo kodas",
    name: "Lithuanian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "lt",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.vmi.lt/",
    subpath: "lt/vat",
  },
  {
    abbreviation: "TVA",
    aliases: ["TVA", "numéro d'identification TVA"],
    canGenerate: true,
    candidatePattern: "LU\\d{8}",
    country: "LU",
    description: null,
    entityType: "company",
    examples: ["15027442"],
    exportName: "vat",
    id: "lu.vat",
    lengths: [8],
    localName: "Numéro de TVA",
    name: "Luxembourg VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "lu",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://pfi.public.lu/",
    subpath: "lu/vat",
  },
  {
    abbreviation: "Luhn",
    aliases: ["Luhn", "Luhn algorithm", "mod 10"],
    canGenerate: true,
    candidatePattern: "\\d{2,}",
    country: null,
    description: null,
    entityType: "any",
    examples: ["4111111111111111", "18"],
    exportName: "luhn",
    id: "luhn",
    lengths: [],
    localName: "Luhn",
    name: "Luhn",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: null,
    parseKind: null,
    scope: "global",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Luhn_algorithm",
    subpath: "luhn",
  },
  {
    abbreviation: "PVN",
    aliases: ["PVN reģistrācijas numurs", "PVN"],
    canGenerate: true,
    candidatePattern: "LV\\d{11}",
    country: "LV",
    description: null,
    entityType: "any",
    examples: ["40003521600", "32999999999"],
    exportName: "vat",
    id: "lv.vat",
    lengths: [],
    localName: "PVN reģistrācijas numurs",
    name: "Latvian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "lv",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.pmlp.gov.lv/en/change-personal-identity-number",
    subpath: "lv/vat",
  },
  {
    abbreviation: "ICE",
    aliases: ["ICE", "Identifiant Commun de l'Entreprise"],
    canGenerate: true,
    candidatePattern: "\\d{15}",
    country: "MA",
    description: "Moroccan common enterprise identifier",
    entityType: "company",
    examples: ["001561191000066", "002136093000040"],
    exportName: "ice",
    id: "ma.ice",
    lengths: [15],
    localName: "Identifiant Commun de l'Entreprise",
    name: "Moroccan Company Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ma",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.ice.gov.ma/",
    subpath: "ma/ice",
  },
  {
    abbreviation: "TVA",
    aliases: ["numéro de TVA", "TVA"],
    canGenerate: true,
    candidatePattern: "FR\\d{11}",
    country: "MC",
    description: null,
    entityType: "company",
    examples: ["FR53000004605"],
    exportName: "tva",
    id: "mc.tva",
    lengths: [],
    localName: "Numéro de TVA",
    name: "Monacan VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "mc",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.economie.gouv.fr/",
    subpath: "mc/tva",
  },
  {
    abbreviation: "IDNO",
    aliases: ["IDNO", "cod de identificare"],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "MD",
    description: null,
    entityType: "company",
    examples: ["1008600038413"],
    exportName: "idno",
    id: "md.idno",
    lengths: [13],
    localName: "IDNO",
    name: "Moldavian Company Identification Number",
    namedExports: ["compact", "format", "validate"],
    namespaceExport: "md",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.idno.md/",
    subpath: "md/idno",
  },
  {
    abbreviation: "PIB",
    aliases: ["PIB"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "ME",
    description: null,
    entityType: "any",
    examples: ["02655284"],
    exportName: "pib",
    id: "me.pib",
    lengths: [8],
    localName: "Poreski identifikacioni broj",
    name: "Montenegrin Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "me",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.tax.gov.me/",
    subpath: "me/pib",
  },
  {
    abbreviation: "EDB",
    aliases: ["ЕДБ", "единствен даночен број", "EDB"],
    canGenerate: true,
    candidatePattern: "MK\\d{13}",
    country: "MK",
    description: null,
    entityType: "any",
    examples: ["4002012527974"],
    exportName: "edb",
    id: "mk.edb",
    lengths: [13],
    localName: "Edinstven danocen broj",
    name: "North Macedonian Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "mk",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.ujp.gov.mk/",
    subpath: "mk/edb",
  },
  {
    abbreviation: "VAT",
    aliases: ["VAT number MT"],
    canGenerate: true,
    candidatePattern: "MT\\d{8}",
    country: "MT",
    description: null,
    entityType: "company",
    examples: ["11679112"],
    exportName: "vat",
    id: "mt.vat",
    lengths: [8],
    localName: "VAT Registration Number",
    name: "Maltese VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "mt",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://cfr.gov.mt/",
    subpath: "mt/vat",
  },
  {
    abbreviation: "BRN",
    aliases: ["BRN", "Business Registration Number"],
    canGenerate: true,
    candidatePattern: "[A-Z]\\d{8}",
    country: "MU",
    description:
      "Mauritius business registration number issued by the CBRD",
    entityType: "any",
    examples: ["C07015330", "C16135302"],
    exportName: "brn",
    id: "mu.brn",
    lengths: [8, 9],
    localName: "Business Registration Number",
    name: "Mauritius Business Registration Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "mu",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://companies.govmu.org/",
    subpath: "mu/brn",
  },
  {
    abbreviation: "CLABE",
    aliases: ["CLABE", "Clave Bancaria Estandarizada"],
    canGenerate: true,
    candidatePattern: "\\d{18}",
    country: "MX",
    description: null,
    entityType: "any",
    examples: ["032180000118359719"],
    exportName: "clabe",
    id: "mx.clabe",
    lengths: [18],
    localName: "Clave Bancaria Estandarizada",
    name: "Mexican Bank Account",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "mx",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://en.wikipedia.org/wiki/CLABE",
    subpath: "mx/clabe",
  },
  {
    abbreviation: "CURP",
    aliases: [
      "CURP",
      "Clave Única de Registro de Población",
    ],
    canGenerate: true,
    candidatePattern:
      "[A-Z]{4}\\d{6}[HM][A-Z]{5}[A-Z\\d]\\d",
    country: "MX",
    description: null,
    entityType: "person",
    examples: ["BOXW310820HNERXN09"],
    exportName: "curp",
    id: "mx.curp",
    lengths: [18],
    localName: "Clave Única de Registro de Población",
    name: "Mexican Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "mx",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://en.wikipedia.org/wiki/CURP",
    subpath: "mx/curp",
  },
  {
    abbreviation: "RFC",
    aliases: ["RFC", "Registro Federal de Contribuyentes"],
    canGenerate: true,
    candidatePattern: "[A-ZÑ&]{3,4}\\d{6}[A-Z\\d]{3}",
    country: "MX",
    description: null,
    entityType: "any",
    examples: ["GODE561231GR8", "MAB9307148T4"],
    exportName: "rfc",
    id: "mx.rfc",
    lengths: [12, 13],
    localName: "Registro Federal de Contribuyentes",
    name: "Mexican Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "mx",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Tax_Identification_Number_(Mexico)",
    subpath: "mx/rfc",
  },
  {
    abbreviation: "NRIC",
    aliases: ["NRIC", "MyKad", "kad pengenalan"],
    canGenerate: true,
    candidatePattern: "\\d{6}-?\\d{2}-?\\d{4}",
    country: "MY",
    description:
      "12-digit identity card number encoding birth date, place of birth, and gender",
    entityType: "person",
    examples: ["770305021234", "880715141234"],
    exportName: "nric",
    id: "my.nric",
    lengths: [12],
    localName: "Nombor Kad Pengenalan",
    name: "Malaysian National Registration Identity Card Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "my",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Malaysian_identity_card",
    subpath: "my/nric",
  },
  {
    abbreviation: "NIN",
    aliases: ["NIN", "National Identification Number"],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "NG",
    description:
      "11-digit national identity number issued by NIMC",
    entityType: "person",
    examples: ["13478900989", "70123456789"],
    exportName: "nin",
    id: "ng.nin",
    lengths: [11],
    localName: "National Identification Number",
    name: "National Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ng",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://nimc.gov.ng/about-nin/",
    subpath: "ng/nin",
  },
  {
    abbreviation: "RUC",
    aliases: ["RUC"],
    canGenerate: true,
    candidatePattern: "[JKME]\\d{13}",
    country: "NI",
    description: "Tax identifier issued by Nicaragua's DGI",
    entityType: "any",
    examples: ["6071904680001F", "2811505850012D"],
    exportName: "ruc",
    id: "ni.ruc",
    lengths: [14],
    localName: "Registro Único de Contribuyente",
    name: "Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ni",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.dgi.gob.ni/",
    subpath: "ni/ruc",
  },
  {
    abbreviation: "BSN",
    aliases: ["burgerservicenummer", "BSN", "sofinummer"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "NL",
    description: null,
    entityType: "person",
    examples: ["111222333"],
    exportName: "bsn",
    id: "nl.bsn",
    lengths: [],
    localName: "Burgerservicenummer",
    name: "Dutch Citizen Service Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "nl",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.government.nl/topics/personal-data/citizen-service-number-bsn",
    subpath: "nl/bsn",
  },
  {
    abbreviation: "KvK",
    aliases: ["KVK-nummer", "Kamer van Koophandel"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "NL",
    description: null,
    entityType: "company",
    examples: ["12345678"],
    exportName: "kvk",
    id: "nl.kvk",
    lengths: [],
    localName: "KvK-nummer",
    name: "Dutch Chamber of Commerce Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "nl",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.kvk.nl/",
    subpath: "nl/kvk",
  },
  {
    abbreviation: "BTW",
    aliases: ["BTW-nummer", "BTW-id"],
    canGenerate: true,
    candidatePattern: "NL\\d{9}B\\d{2}",
    country: "NL",
    description: null,
    entityType: "company",
    examples: ["000099998B57"],
    exportName: "vat",
    id: "nl.vat",
    lengths: [],
    localName: "BTW-identificatienummer",
    name: "Dutch VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "nl",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://business.gov.nl/regulations/using-checking-vat-numbers/",
    subpath: "nl/vat",
  },
  {
    abbreviation: "Fødselsnr",
    aliases: ["fødselsnummer", "personnummer"],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "NO",
    description: null,
    entityType: "person",
    examples: ["15108695088"],
    exportName: "fodselsnummer",
    id: "no.fodselsnummer",
    lengths: [],
    localName: "Fødselsnummer",
    name: "Norwegian Birth Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "no",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://www.skatteetaten.no/",
    subpath: "no/fodselsnummer",
  },
  {
    abbreviation: "MVA",
    aliases: ["MVA-nummer", "organisasjonsnummer"],
    canGenerate: true,
    candidatePattern: "NO\\d{9}MVA",
    country: "NO",
    description: null,
    entityType: "company",
    examples: ["995525828MVA"],
    exportName: "mva",
    id: "no.mva",
    lengths: [],
    localName: "Merverdiavgift",
    name: "Norwegian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "no",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.skatteetaten.no/",
    subpath: "no/mva",
  },
  {
    abbreviation: "Orgnr",
    aliases: ["organisasjonsnummer", "org.nr"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "NO",
    description: null,
    entityType: "company",
    examples: ["923609016"],
    exportName: "orgnr",
    id: "no.orgnr",
    lengths: [],
    localName: "Organisasjonsnummer",
    name: "Norwegian Organization Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "no",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.brreg.no/",
    subpath: "no/orgnr",
  },
  {
    abbreviation: "IRD",
    aliases: ["IRD number", "tax number NZ"],
    canGenerate: true,
    candidatePattern: "\\d{8,9}",
    country: "NZ",
    description:
      "New Zealand Inland Revenue Department number",
    entityType: "any",
    examples: ["49091850", "136410132"],
    exportName: "ird",
    id: "nz.ird",
    lengths: [8, 9],
    localName: "IRD Number",
    name: "IRD Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "nz",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.ird.govt.nz/",
    subpath: "nz/ird",
  },
  {
    abbreviation: "RUC",
    aliases: ["RUC"],
    canGenerate: true,
    candidatePattern: "\\d{1,2}-?\\d{1,4}-?\\d{1,6}",
    country: "PA",
    description: "Tax identifier issued by Panama's DGI",
    entityType: "any",
    examples: ["1-184-921 DV49", "2588017-1-831938 DV20"],
    exportName: "ruc",
    id: "pa.ruc",
    lengths: [],
    localName: "Registro Único de Contribuyente",
    name: "Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "pa",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://dgi.mef.gob.pa/",
    subpath: "pa/ruc",
  },
  {
    abbreviation: "RUC",
    aliases: ["RUC"],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "PE",
    description: null,
    entityType: "any",
    examples: ["20131312955", "20100047218"],
    exportName: "ruc",
    id: "pe.ruc",
    lengths: [11],
    localName: "Registro Único de Contribuyentes",
    name: "Peruvian Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "pe",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.sunat.gob.pe/",
    subpath: "pe/ruc",
  },
  {
    abbreviation: "PhilID",
    aliases: ["PhilID", "PhilSys", "Philippine ID"],
    canGenerate: true,
    candidatePattern: "\\d{4}-\\d{4}-\\d{4}-\\d{4}",
    country: "PH",
    description:
      "12-digit personal identifier issued under the Philippine Identification System",
    entityType: "person",
    examples: ["123456789012", "000011112222"],
    exportName: "philid",
    id: "ph.philid",
    lengths: [12],
    localName: "PhilSys Card Number",
    name: "Philippine Identification System Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ph",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Philippine_national_identity_card",
    subpath: "ph/philid",
  },
  {
    abbreviation: "CNIC",
    aliases: ["CNIC", "شناختی کارڈ"],
    canGenerate: true,
    candidatePattern: "\\d{5}-?\\d{7}-?\\d",
    country: "PK",
    description:
      "13-digit identity card number issued by NADRA",
    entityType: "person",
    examples: ["3520112345671", "4210112345672"],
    exportName: "cnic",
    id: "pk.cnic",
    lengths: [13],
    localName: "Computerized National Identity Card",
    name: "Computerized National Identity Card",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "pk",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/CNIC_(Pakistan)",
    subpath: "pk/cnic",
  },
  {
    abbreviation: "NIP",
    aliases: ["NIP", "numer identyfikacji podatkowej"],
    canGenerate: true,
    candidatePattern: "\\d{3}-?\\d{3}-?\\d{2}-?\\d{2}",
    country: "PL",
    description: null,
    entityType: "company",
    examples: ["2234567895"],
    exportName: "nip",
    id: "pl.nip",
    lengths: [],
    localName: "Numer Identyfikacji Podatkowej",
    name: "Polish VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "pl",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.biznes.gov.pl/en/portal/004124",
    subpath: "pl/nip",
  },
  {
    abbreviation: "PESEL",
    aliases: ["PESEL"],
    canGenerate: true,
    candidatePattern: "\\d{11}",
    country: "PL",
    description: null,
    entityType: "person",
    examples: ["02070803628"],
    exportName: "pesel",
    id: "pl.pesel",
    lengths: [],
    localName:
      "Powszechny Elektroniczny System Ewidencji Ludności",
    name: "Polish National ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "pl",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.gov.pl/web/cyfryzacja/numer-pesel",
    subpath: "pl/pesel",
  },
  {
    abbreviation: "REGON",
    aliases: ["REGON", "numer statystyczny"],
    canGenerate: true,
    candidatePattern: "\\d{9,14}",
    country: "PL",
    description: null,
    entityType: "company",
    examples: ["123456785", "12345678512347"],
    exportName: "regon",
    id: "pl.regon",
    lengths: [],
    localName: "Rejestr Gospodarki Narodowej",
    name: "Polish Business Register Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "pl",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://bip.stat.gov.pl/en/regon/",
    subpath: "pl/regon",
  },
  {
    abbreviation: "CC",
    aliases: [
      "cartão de cidadão",
      "CC",
      "número de identificação civil",
    ],
    canGenerate: true,
    candidatePattern: "\\d{8}\\s?\\d\\s?[A-Z]{2}\\d",
    country: "PT",
    description:
      "Alphanumeric national identity card number with Luhn-like check digit",
    entityType: "person",
    examples: ["000000000ZZ8"],
    exportName: "cc",
    id: "pt.cc",
    lengths: [12],
    localName: "Cartão de Cidadão",
    name: "Portuguese Identity Card",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "pt",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://pt.wikipedia.org/wiki/Cartão_de_cidadão",
    subpath: "pt/cc",
  },
  {
    abbreviation: "NIF",
    aliases: [
      "NIF",
      "número de identificação fiscal",
      "contribuinte",
    ],
    canGenerate: true,
    candidatePattern: "PT\\d{9}",
    country: "PT",
    description: null,
    entityType: "any",
    examples: ["501964843"],
    exportName: "vat",
    id: "pt.vat",
    lengths: [9],
    localName: "Número de Identificação Fiscal",
    name: "Portuguese VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "pt",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.portaldasfinancas.gov.pt/",
    subpath: "pt/vat",
  },
  {
    abbreviation: "CNP",
    aliases: ["CNP", "cod numeric personal"],
    canGenerate: true,
    candidatePattern:
      "[1-8]\\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\\d|3[01])\\d{6}",
    country: "RO",
    description: null,
    entityType: "person",
    examples: ["1630615123457"],
    exportName: "cnp",
    id: "ro.cnp",
    lengths: [13],
    localName: "Cod Numeric Personal",
    name: "Romanian Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "ro",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://www.cnp.ro/",
    subpath: "ro/cnp",
  },
  {
    abbreviation: "CIF",
    aliases: [
      "CUI",
      "CIF",
      "cod de identificare fiscală",
      "cod fiscal",
    ],
    canGenerate: true,
    candidatePattern: "RO\\d{2,10}",
    country: "RO",
    description: null,
    entityType: "any",
    examples: ["18547290"],
    exportName: "vat",
    id: "ro.vat",
    lengths: [2, 3, 4, 5, 6, 7, 8, 9, 10],
    localName: "Cod de Identificare Fiscală",
    name: "Romanian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ro",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.anaf.ro/",
    subpath: "ro/vat",
  },
  {
    abbreviation: "PIB",
    aliases: ["PIB", "poreski identifikacioni broj"],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "RS",
    description: null,
    entityType: "any",
    examples: ["101134702"],
    exportName: "pib",
    id: "rs.pib",
    lengths: [9],
    localName: "Poreski identifikacioni broj",
    name: "Serbian Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "rs",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.purs.gov.rs/",
    subpath: "rs/pib",
  },
  {
    abbreviation: "ИНН",
    aliases: ["ИНН", "INN"],
    canGenerate: true,
    candidatePattern: "\\d{10,12}",
    country: "RU",
    description: null,
    entityType: "any",
    examples: ["7707083893", "526317984689"],
    exportName: "inn",
    id: "ru.inn",
    lengths: [10, 12],
    localName: "Идентификационный номер налогоплательщика",
    name: "Russian Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ru",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.nalog.gov.ru/",
    subpath: "ru/inn",
  },
  {
    abbreviation: "Orgnr",
    aliases: ["organisationsnummer", "org.nr", "org nr"],
    canGenerate: true,
    candidatePattern: "\\d{6}-\\d{4}",
    country: "SE",
    description: null,
    entityType: "company",
    examples: ["1234567897"],
    exportName: "orgnr",
    id: "se.orgnr",
    lengths: [],
    localName: "Organisationsnummer",
    name: "Swedish Organization Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "se",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.skatteverket.se/",
    subpath: "se/orgnr",
  },
  {
    abbreviation: "PN",
    aliases: [
      "personnummer",
      "personnr",
      "pers.nr",
      "personal identity number",
    ],
    canGenerate: true,
    candidatePattern: "\\d{6,8}-\\d{4}",
    country: "SE",
    description: null,
    entityType: "person",
    examples: ["880320-0016"],
    exportName: "personnummer",
    id: "se.personnummer",
    lengths: [],
    localName: "Personnummer",
    name: "Swedish Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "se",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.skatteverket.se/privat/folkbokforing/personnummer.4.3810a01c150939e893f18c29.html",
    subpath: "se/personnummer",
  },
  {
    abbreviation: "Momsnr.",
    aliases: [
      "Momsnr.",
      "Momsregistreringsnummer",
      "Swedish VAT Number",
      "SE VAT",
    ],
    canGenerate: true,
    candidatePattern: "SE\\s?\\d{10}01",
    country: "SE",
    description: null,
    entityType: "company",
    examples: ["556188840401"],
    exportName: "vat",
    id: "se.vat",
    lengths: [12],
    localName: "Momsregistreringsnummer",
    name: "Swedish VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "se",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.skatteverket.se/",
    subpath: "se/vat",
  },
  {
    abbreviation: "UEN",
    aliases: ["UEN", "Unique Entity Number"],
    canGenerate: true,
    candidatePattern: "[\\dSTR]\\d{7}[A-Z]",
    country: "SG",
    description:
      "9 or 10-character business identifier issued by ACRA",
    entityType: "company",
    examples: ["00192200M", "197401143C", "S16FC0121D"],
    exportName: "uen",
    id: "sg.uen",
    lengths: [9, 10],
    localName: "Unique Entity Number",
    name: "Singapore Unique Entity Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "sg",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.uen.gov.sg/",
    subpath: "sg/uen",
  },
  {
    abbreviation: "EMŠO",
    aliases: ["EMŠO", "enotna matična številka občana"],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "SI",
    description: null,
    entityType: "person",
    examples: ["0101006500006"],
    exportName: "emso",
    id: "si.emso",
    lengths: [],
    localName: "Enotna matična številka občana",
    name: "Slovenian Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "si",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://www.gov.si/teme/registri-in-evidence-prebivalstva/",
    subpath: "si/emso",
  },
  {
    abbreviation: "DDV",
    aliases: ["DDV", "identifikacijska številka za DDV"],
    canGenerate: true,
    candidatePattern: "SI\\d{8}",
    country: "SI",
    description: null,
    entityType: "company",
    examples: ["15012557"],
    exportName: "vat",
    id: "si.vat",
    lengths: [8],
    localName: "Davčna številka",
    name: "Slovenian VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "si",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.fu.gov.si/",
    subpath: "si/vat",
  },
  {
    abbreviation: "IČ DPH",
    aliases: ["DIČ", "daňové identifikačné číslo"],
    canGenerate: true,
    candidatePattern: "SK\\d{10}",
    country: "SK",
    description: null,
    entityType: "company",
    examples: ["2021853504"],
    exportName: "dic",
    id: "sk.dic",
    lengths: [],
    localName:
      "Identifikačné číslo pre daň z pridanej hodnoty",
    name: "Slovak VAT Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "sk",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.financnasprava.sk/",
    subpath: "sk/dic",
  },
  {
    abbreviation: "IČO",
    aliases: ["IČO", "identifikačné číslo organizácie"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "SK",
    description: null,
    entityType: "company",
    examples: ["25123891"],
    exportName: "ico",
    id: "sk.ico",
    lengths: [],
    localName: "Identifikačné číslo organizácie",
    name: "Slovak Company ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "sk",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.statistics.sk/",
    subpath: "sk/ico",
  },
  {
    abbreviation: "RČ",
    aliases: ["rodné číslo", "RČ"],
    canGenerate: true,
    candidatePattern: "\\d{6}/\\d{3,4}",
    country: "SK",
    description: null,
    entityType: "person",
    examples: ["7103192745"],
    exportName: "rc",
    id: "sk.rc",
    lengths: [9, 10],
    localName: "Rodné číslo",
    name: "Slovak Birth Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "sk",
    parseKind: "person",
    scope: "country",
    sourceUrl: "https://www.minv.sk/",
    subpath: "sk/rc",
  },
  {
    abbreviation: "TIN",
    aliases: ["เลขประจำตัวผู้เสียภาษี", "TIN"],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "TH",
    description:
      "13-digit tax identifier for individuals and companies",
    entityType: "any",
    examples: ["1101700230708", "3100600445015"],
    exportName: "tin",
    id: "th.tin",
    lengths: [13],
    localName: "เลขประจำตัวผู้เสียภาษี",
    name: "Thai Tax Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "th",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.rd.go.th/",
    subpath: "th/tin",
  },
  {
    abbreviation: "T.C. Kimlik",
    aliases: ["TC Kimlik No", "T.C. Kimlik Numarası"],
    canGenerate: true,
    candidatePattern: "[1-9]\\d{10}",
    country: "TR",
    description: null,
    entityType: "person",
    examples: ["17291716060"],
    exportName: "tckimlik",
    id: "tr.tckimlik",
    lengths: [],
    localName: "T.C. Kimlik Numarası",
    name: "Turkish Personal ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "tr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.nvi.gov.tr/",
    subpath: "tr/tckimlik",
  },
  {
    abbreviation: "VKN",
    aliases: ["VKN", "Vergi Kimlik Numarası"],
    canGenerate: true,
    candidatePattern: "\\d{10}",
    country: "TR",
    description: null,
    entityType: "company",
    examples: ["4540536920"],
    exportName: "vkn",
    id: "tr.vkn",
    lengths: [],
    localName: "Vergi Kimlik Numarası",
    name: "Turkish Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "tr",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.gib.gov.tr/",
    subpath: "tr/vkn",
  },
  {
    abbreviation: "UBN",
    aliases: ["統一編號", "UBN"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "TW",
    description:
      "8-digit company identifier issued by the Ministry of Economic Affairs",
    entityType: "company",
    examples: ["00501503", "04595257"],
    exportName: "ubn",
    id: "tw.ubn",
    lengths: [8],
    localName: "統一編號",
    name: "Unified Business Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "tw",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://zh.wikipedia.org/wiki/%E7%B5%B1%E4%B8%80%E7%B7%A8%E8%99%9F",
    subpath: "tw/ubn",
  },
  {
    abbreviation: "ЄДРПОУ",
    aliases: ["ЄДРПОУ", "EDRPOU"],
    canGenerate: true,
    candidatePattern: "\\d{8}",
    country: "UA",
    description: null,
    entityType: "company",
    examples: ["14360570"],
    exportName: "edrpou",
    id: "ua.edrpou",
    lengths: [8],
    localName: "ЄДРПОУ",
    name: "Ukrainian Company Register Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ua",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://usr.minjust.gov.ua/",
    subpath: "ua/edrpou",
  },
  {
    abbreviation: "EIN",
    aliases: [
      "EIN",
      "Employer Identification Number",
      "Federal Tax ID",
    ],
    canGenerate: true,
    candidatePattern: "\\d{2}-?\\d{7}",
    country: "US",
    description: null,
    entityType: "company",
    examples: ["042103594"],
    exportName: "ein",
    id: "us.ein",
    lengths: [],
    localName: "Employer Identification Number",
    name: "Employer Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "us",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.irs.gov/businesses/small-businesses-self-employed/how-eins-are-assigned-and-valid-ein-prefixes",
    subpath: "us/ein",
  },
  {
    abbreviation: "ITIN",
    aliases: [
      "ITIN",
      "Individual Taxpayer Identification Number",
    ],
    canGenerate: true,
    candidatePattern: "9\\d{2}[\\s-]?\\d{2}[\\s-]?\\d{4}",
    country: "US",
    description: null,
    entityType: "person",
    examples: ["912-90-3456"],
    exportName: "itin",
    id: "us.itin",
    lengths: [9],
    localName: "Individual Taxpayer Identification Number",
    name: "Individual Taxpayer Identification Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "us",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://www.irs.gov/individuals/individual-taxpayer-identification-number",
    subpath: "us/itin",
  },
  {
    abbreviation: "RTN",
    aliases: [
      "RTN",
      "ABA",
      "Routing Number",
      "ABA Routing Number",
      "Routing Transit Number",
    ],
    canGenerate: true,
    candidatePattern: "\\d{9}",
    country: "US",
    description: null,
    entityType: "company",
    examples: ["111000025", "021000021"],
    exportName: "rtn",
    id: "us.rtn",
    lengths: [9],
    localName: "Routing Transit Number",
    name: "Routing Transit Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "us",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/ABA_routing_transit_number",
    subpath: "us/rtn",
  },
  {
    abbreviation: "SSN",
    aliases: ["SSN", "Social Security Number"],
    canGenerate: true,
    candidatePattern: "\\d{3}-?\\d{2}-?\\d{4}",
    country: "US",
    description: null,
    entityType: "person",
    examples: ["536904399"],
    exportName: "ssn",
    id: "us.ssn",
    lengths: [],
    localName: "Social Security Number",
    name: "Social Security Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "us",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.ssa.gov/employer/verifySSN.htm",
    subpath: "us/ssn",
  },
  {
    abbreviation: "RUT",
    aliases: ["RUT", "Registro Único Tributario"],
    canGenerate: true,
    candidatePattern: "\\d{12}",
    country: "UY",
    description: null,
    entityType: "any",
    examples: ["010100010013", "102000010017"],
    exportName: "rut",
    id: "uy.rut",
    lengths: [12],
    localName: "Registro Único Tributario",
    name: "Uruguayan Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "uy",
    parseKind: null,
    scope: "country",
    sourceUrl: "https://www.agesic.gub.uy/",
    subpath: "uy/rut",
  },
  {
    abbreviation: "RIF",
    aliases: ["RIF", "Registro de Información Fiscal"],
    canGenerate: true,
    candidatePattern: "[VEJPG]-?\\d{8}-?\\d",
    country: "VE",
    description: null,
    entityType: "any",
    examples: ["V309876543", "J309876546"],
    exportName: "rif",
    id: "ve.rif",
    lengths: [10],
    localName: "Registro de Información Fiscal",
    name: "Venezuelan Tax ID",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "ve",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/Tax_Identification_Number#Venezuela",
    subpath: "ve/rif",
  },
  {
    abbreviation: "MST",
    aliases: ["MST", "mã số thuế"],
    canGenerate: true,
    candidatePattern: "\\d{10}(-\\d{3})?",
    country: "VN",
    description:
      "10- or 13-digit tax identifier for enterprises",
    entityType: "company",
    examples: ["0100233488", "0314409058002"],
    exportName: "mst",
    id: "vn.mst",
    lengths: [10, 13],
    localName: "Mã số thuế",
    name: "Vietnamese Tax Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "validate",
    ],
    namespaceExport: "vn",
    parseKind: null,
    scope: "country",
    sourceUrl:
      "https://vi.wikipedia.org/wiki/Thu%E1%BA%BF_Vi%E1%BB%87t_Nam#M%C3%A3_s%E1%BB%91_thu%E1%BA%BF_(MST)_c%E1%BB%A7a_doanh_nghi%E1%BB%87p",
    subpath: "vn/mst",
  },
  {
    abbreviation: "SA ID",
    aliases: ["ID number", "RSA ID"],
    canGenerate: true,
    candidatePattern: "\\d{13}",
    country: "ZA",
    description:
      "South African personal identification number",
    entityType: "person",
    examples: ["7503305044089", "8001015009087"],
    exportName: "idnr",
    id: "za.idnr",
    lengths: [13],
    localName: "South African Identity Number",
    name: "South African Identity Number",
    namedExports: [
      "compact",
      "format",
      "generate",
      "parse",
      "validate",
    ],
    namespaceExport: "za",
    parseKind: "person",
    scope: "country",
    sourceUrl:
      "https://en.wikipedia.org/wiki/South_African_identity_document",
    subpath: "za/idnr",
  },
] as const;
